import pages  from '../../config/pages.json';
import * as rFuncs from './ResponseFunctions';
import { useResponsesStore } from '../stores/Responses';

export const getNextPagePath = (order) => {
    let nextPage;
    let next = order;

    do {
        next++;
        nextPage = pages.find((page) => page.order === next);
    } while (!checkPageDependencies(nextPage));

    const path =  nextPage?.path ?? null;
    return path;
}

export const getPrevPagePath = (order) => {
    let prevPage;
    let prev = order;

    do {
        prev--;

        prevPage = pages.find((page) => page.order === prev);
    } while (!checkPageDependencies(prevPage));

    const path = prevPage?.path ?? null;
    return path;
}

export const pageCount = () => {
    return pages.length;
}

export const getCurrentPage = (pageId) => {
    return pages.find((page) => page.id === pageId);
}

export const getPageOrder = (page) => {
    return page.order;
}

const checkPageDependencies = (page) => {
    if (!page?.dependencies) return true;

    const responses = useResponsesStore.getState().responses;

    if (page.dependAll) {
        // If dependAll is true, all dependencies must be satisfied
        return page.dependencies.every((dep) => {
            if (dep.function) {
                const func = dep.function;
                return rFuncs[func](responses);
            }
            
            const response = responses.find((res) => res.id === dep.question);
            if (dep.values.includes(null) && !response) return true; // null means no response is required
            if (!response) return false;
            
            return response && dep.values.includes(response.value);
        });
    } else {
        // Default behavior (some): at least one dependency must be satisfied
        return page.dependencies.some((dep) => {
            if (dep.function) {
                const func = dep.function;
                return rFuncs[func](responses);
            }
            
            const response = responses.find((res) => res.id === dep.question);
            if (!response) return false;
            
            return response && dep.values.includes(response.value);
        });
    }
}